import moment from "moment";
import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import alertimg from "../../../../../Images/NewUI/alert.png";
import Calander from "../../../../../Images/NewUI/calender.png";
import WhiteSpark from "../../../../../Images/NewUI/circle-arrow.png";
import greenDot from "../../../../../Images/NewUI/green.png";
import { notifyVisitorEvent } from "../../../../../Redux/ApplyLoan/action";
import ToastMsg from "../../../../../helper/ToastMsg";
import PreCloserTile from "./PreCloserLoan";

const SuperApprepay = () => {
  const navigate = useNavigate();
  
  const {
    loanStatus: loanData,
    precloserShow,
  } = useSelector((state) => state.dashboard);

  const [isButtonDisabled, setisButtonDisabled] = useState(true);

  const repayment_screen = loanData?.repayment_screen_show || "";
  const collectionAmount = loanData?.collection_amount || 0;
  const balanceAmount = loanData?.due_amount || 0;
  const loanClosure = loanData?.foreclosure_loan || false;
  const loan_type = loanData?.loan_type || "P";

  const { dueAmount, repaymentDate } = useMemo(() => {
    if (!loanData) return { dueAmount: 0, repaymentDate: "" };
    
    if (loanData?.loan_type === "P") {
      return {
        dueAmount: loanData?.due_amount || 0,
        repaymentDate: loanData?.repayment_date || "",
      };
    } else {
      let allEmiAmount = 0;
      let unpaidIndex = false;
      let repayDate = "";
      const emiDetails = loanData?.emi_details || [];
      
      for (let i = 0; i < emiDetails.length; i++) {
        if (emiDetails[i].status === "UNPAID") {
          allEmiAmount += emiDetails[i]?.due_amount || 0;
          const today = new Date();
          const isRepaymentDateAfterToday = new Date(emiDetails[i]?.repayment_date) > today;
          if (!unpaidIndex) {
            repayDate = emiDetails[i]?.repayment_date || "";
          }
          unpaidIndex = true;
          if (isRepaymentDateAfterToday) {
            break;
          }
        }
      }
      return { dueAmount: allEmiAmount, repaymentDate: repayDate };
    }
  }, [loanData]);

  const applyloan = () => {
    const payload = {
      event_name: "Interacted_SuperApp_Dashboard",
      event_body: {
        Platform: "m-site",
        "User Type": localStorage.getItem("user_type"),
        "Credit Limit amount EMI": localStorage.getItem("emiAmount") || 0,
        "Credit Limit amount Payday": localStorage.getItem("paydayAmount") || 0,
        "Loan type EMI": localStorage.getItem("E") || "",
        "Loan type Payday": localStorage.getItem("P") || "",
        "Can Apply On": localStorage.getItem("can_apply"),
        "Clicked on": loanData?.loan_type === "P" ? "Repay Now_Payday" : "Repay Now_EMI",
      },
    };
    
    notifyVisitorEvent(payload).catch(() => {});

    if (repayment_screen === "repayment_screen") {
      navigate("/loan_repay");
    } else if (isButtonDisabled) {
      ToastMsg("Your repayment will be auto debited via ECS", "success");
      setisButtonDisabled(false);
      setTimeout(() => setisButtonDisabled(true), 4000);
    }
  };

  const getDaysDifference = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    return Math.floor((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24));
  };

  const formattedRepayDate = moment(repaymentDate).format("YYYY-MM-DD");
  const todayFormatted = moment().format("YYYY-MM-DD");
  const result = Number(getDaysDifference(formattedRepayDate, todayFormatted));

  return (
    <div className="bg-white rounded-3 shadow-sm p-3 mt-3 mx-3">
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex flex-column">
          <div className="d-flex align-items-center mb-2">
            <img
              src={greenDot}
              alt="active"
              width={12}
              height={12}
              className="me-2"
            />
            <span style={{ fontSize: "18px", fontWeight: "700", color: "#152745" }}>
              Active Loan
            </span>
          </div>
          
          <span style={{ fontSize: "14px", color: "#666", marginBottom: "4px" }}>
            {loan_type === "P" ? "Payable Amount:" : "EMI Amount:"}
          </span>
          
          <span style={{ fontSize: "24px", fontWeight: "700", color: "#152745", lineHeight: "1.2" ,textAlign:"start"}}>
            <span style={{ fontWeight: "400" }}>₹</span>
            {dueAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
          </span>
          
          <div style={{ fontSize: "14px", color: "#666", marginTop: "8px" }}>
            <span style={{ fontWeight: "600", color: "#152745" }}>Due on: </span>
            {moment(repaymentDate).format("DD MMM' YY")}
          </div>
        </div>

        {/* Right Section - Calendar, Days & Button */}
        <div className="d-flex flex-column align-items-center">
          {result > 0 ? (
            <>
              <img
                src={alertimg}
                alt="alert"
                style={{ width: 40, height: 40, marginBottom: 8 }}
              />
              <span style={{ fontSize: "14px", color: "red", fontWeight: "600", marginBottom: 12 }}>
                Overdue by {Math.abs(result)} Days
              </span>
              <div
                onClick={applyloan}
                style={{
                  background: "linear-gradient(135deg, #2788D9 0%, hsl(152 60% 53%) 100%)",
                  borderRadius: "10px",
                  padding: "10px 20px",
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  minWidth: "130px",
                  justifyContent: "center"
                }}
              >
                <span style={{ color: "#fff", fontSize: "14px", fontWeight: "600" }}>
                  Repay Now
                </span>
                <img
                  src={WhiteSpark}
                  style={{ marginLeft: 8 }}
                  height={16}
                  width={16}
                  alt="arrow"
                />
              </div>
              {loanClosure && (
                <div
                  onClick={() => navigate("/loan_foreclosure")}
                  style={{
                    marginTop: 10,
                    fontSize: "13px",
                    color: "#FC6603",
                    fontWeight: "600",
                    cursor: "pointer"
                  }}
                >
                  Foreclose Loan
                </div>
              )}
            </>
          ) : result === 0 ? (
            <>
              <img
                src={Calander}
                alt="calendar"
                style={{ width: 44, height: 48, marginBottom: 8 }}
              />
              <span style={{ fontSize: "14px", color: "#16C96F", fontWeight: "600", marginBottom: 12 }}>
                Today is your due date
              </span>
              <div
                onClick={applyloan}
                style={{
                  background: "linear-gradient(135deg, #2788D9 0%, hsl(152 60% 53%) 100%)",
                  borderRadius: "10px",
                  padding: "10px 20px",
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  minWidth: "130px",
                  justifyContent: "center"
                }}
              >
                <span style={{ color: "#fff", fontSize: "14px", fontWeight: "600" }}>
                  Repay Now
                </span>
                <img
                  src={WhiteSpark}
                  style={{ marginLeft: 8 }}
                  height={16}
                  width={16}
                  alt="arrow"
                />
              </div>
              {loanClosure && (
                <div
                  onClick={() => navigate("/loan_foreclosure")}
                  style={{
                    marginTop: 10,
                    fontSize: "13px",
                    color: "#FC6603",
                    fontWeight: "600",
                    cursor: "pointer"
                  }}
                >
                  Foreclose Loan
                </div>
              )}
            </>
          ) : (
            <>
              <img
                src={Calander}
                alt="calendar"
                style={{ width: 44, height: 48, marginBottom: 8 }}
              />
              <span style={{ fontSize: "16px", color: "#16C96F", fontWeight: "600", marginBottom: 12 }}>
                {Math.abs(result)} Days left
              </span>
              <div
                onClick={applyloan}
                style={{
                  background: "linear-gradient(135deg, #2788D9 0%, hsl(152 60% 53%) 100%)",
                  borderRadius: "10px",
                  padding: "10px 20px",
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  minWidth: "130px",
                  justifyContent: "center"
                }}
              >
                <span style={{ color: "#fff", fontSize: "14px", fontWeight: "600" }}>
                  Repay Now
                </span>
                <img
                  src={WhiteSpark}
                  style={{ marginLeft: 8 }}
                  height={16}
                  width={16}
                  alt="arrow"
                />
              </div>
              {loanClosure && (
                <div
                  onClick={() => navigate("/loan_foreclosure")}
                  style={{
                    marginTop: 10,
                    fontSize: "13px",
                    color: "#FC6603",
                    fontWeight: "600",
                    cursor: "pointer"
                  }}
                >
                  Foreclose Loan
                </div>
              )}
            </>
          )}
        </div>
      </div>
      
      {precloserShow && <PreCloserTile />}
    </div>
  );
};

export default SuperApprepay;
